import { createAction, createStandardAction } from 'typesafe-actions';

import { ChargebeeCardDetailsDTO } from '../../types/dto/ChargebeeCardDetailsDTO';
import { ChargebeeCouponDTO } from '../../types/dto/ChargebeeCouponDTO';
import { ChargebeePlanDTO } from '../../types/dto/ChargebeePlanDTO';
import { ChargebeeSubscriptionDTO } from '../../types/dto/ChargebeeSubscriptionDTO';
import { SubscriptionCreditNoteDTO } from '../../types/dto/SubscriptionCreditNoteDTO';
import { SubscriptionInvoiceDTO } from '../../types/dto/SubscriptionInvoiceDTO';
import { SubscriptionItemDTO } from '../../types/dto/SubscriptionItemDTO';
import { SubscriptionErrorInfo } from './Types';

export const getActivePlansRequest = createAction('@@app/GET_ACTIVE_PLANS_REQUEST');
export const getActivePlansSuccess = createStandardAction('@@app/GET_ACTIVE_PLANS_SUCCESS')<ChargebeePlanDTO[]>();
export const getActivePlansFailure = createAction('@@app/GET_ACTIVE_PLANS_FAILURE');

export const getSubscriptionItemsRequest = createAction('@@app/GET_SUBSCRIPTION_ITEMS_REQUEST');
export const getSubscriptionItemsSuccess = createStandardAction('@@app/GET_SUBSCRIPTION_ITEMS_SUCCESS')<SubscriptionItemDTO[]>();
export const getSubscriptionItemsFailure = createAction('@@app/GET_SUBSCRIPTION_ITEMS_FAILURE');

export const getUserSubscriptionsRequest = createAction('@@app/GET_USER_SUBSCRIPTIONS_REQUEST');
export const getUserSubscriptionsSuccess = createStandardAction('@@app/GET_USER_SUBSCRIPTIONS_SUCCESS')<ChargebeeSubscriptionDTO[]>();
export const getUserSubscriptionsFailure = createAction('@@app/GET_USER_SUBSCRIPTIONS_FAILURE');

export const getPrimaryPaymentSourceRequest = createAction('@@app/GET_PRIMARY_PAYMENT_SOURCE_REQUEST');
export const getPrimaryPaymentSourceSuccess = createStandardAction('@@app/GET_PRIMARY_PAYMENT_SOURCE_SUCCESS')<ChargebeeCardDetailsDTO>();
export const getPrimaryPaymentSourceFailure = createAction('@@app/GET_PRIMARY_PAYMENT_SOURCE_FAILURE');

export const getUserSubscriptionInvoicesRequest = createAction('@@app/GET_USER_SUBSCRIPTION_INVOICES_REQUEST');
export const getUserSubscriptionInvoicesSuccess = createStandardAction('@@app/GET_USER_SUBSCRIPTION_INVOICES_SUCCESS')<SubscriptionInvoiceDTO[]>();
export const getUserSubscriptionInvoicesFailure = createAction('@@app/GET_USER_SUBSCRIPTION_INVOICES_FAILURE');

export const getUserSubscriptionCreditNotesRequest = createAction('@@app/GET_USER_SUBSCRIPTION_CREDITE_NOTES_REQUEST');
export const getUserSubscriptionCreditNotesSuccess = createStandardAction('@@app/GET_USER_SUBSCRIPTION_CREDITE_NOTES_SUCCESS')<SubscriptionCreditNoteDTO[]>();
export const getUserSubscriptionCreditNotesFailure = createAction('@@app/GET_USER_SUBSCRIPTION_CREDITE_NOTES_FAILURE');

export const updatePaymentSourceRequest = createAction('@@app/UPDATE_PAYMENT_SOURCE_REQUEST');
export const updatePaymentSourceSuccess = createStandardAction('@@app/UPDATE_PAYMENT_SOURCE_SUCCESS')<boolean>();
export const updatePaymentSourceFailure = createAction('@@app/UPDATE_PAYMENT_SOURCE_FAILURE');

export const getCouponDetailsRequest = createAction('@@app/GET_COUPON_DETAILS_REQUEST');
export const getCouponDetailsSuccess = createStandardAction('@@app/GET_COUPON_DETAILS_SUCCESS')<ChargebeeCouponDTO>();
export const getCouponDetailsFailure = createAction('@@app/GET_COUPON_DETAILS_FAILURE');

export const updateVehicleFromDOMRequest = createAction('@@app/UPDATE_VEHICLE_FROM_DOM_REQUEST');
export const updateVehicleFromDOMSuccess = createAction('@@app/UPDATE_VEHICLE_FROM_DOM_SUCCESS');
export const updateVehicleFromDOMFailure = createAction('@@app/UPDATE_VEHICLE_FROM_DOM_FAILURE');

export const createSubscriptionV2Request = createAction('@@app/CREATE_SUBSCRIPTION_V2_REQUEST');
export const createSubscriptionV2Success = createStandardAction('@@app/CREATE_SUBSCRIPTION_V2_SUCCESS')<ChargebeeSubscriptionDTO>();
export const createSubscriptionV2Failure = createStandardAction('@@app/CREATE_SUBSCRIPTION_V2_FAILURE')<SubscriptionErrorInfo>();

export const cancelSubscriptionRequest = createAction('@@app/CANCEL_SUBSCRIPTION_REQUEST');
export const cancelSubscriptionSuccess = createStandardAction('@@app/CANCEL_SUBSCRIPTION_SUCCESS')<ChargebeeSubscriptionDTO>();
export const cancelSubscriptionFailure = createAction('@@app/CANCEL_SUBSCRIPTION_FAILURE');

export const printSubscriptionInvoiceRequest = createAction('@@app/PRINT_SUBSCRIPTION_INVOICE_REQUEST');
export const printSubscriptionInvoiceSuccess = createStandardAction('@@app/PRINT_SUBSCRIPTION_INVOICE_SUCCESS')<Blob>();
export const printSubscriptionInvoiceFailure = createStandardAction('@@app/PRINT_SUBSCRIPTION_INVOICE_FAILURE')<SubscriptionErrorInfo>();

export const printSubscriptionCreditNoteRequest = createAction('@@app/PRINT_SUBSCRIPTION_CREDIT_NOTE_REQUEST');
export const printSubscriptionCreditNoteSuccess = createStandardAction('@@app/PRINT_SUBSCRIPTION_CREDIT_NOTE_SUCCESS')<Blob>();
export const printSubscriptionCreditNoteFailure = createStandardAction('@@app/PRINT_SUBSCRIPTION_CREDIT_NOTE_FAILURE')<SubscriptionErrorInfo>();
export const getAdyenPaymentMethodsRequest = createAction('@@app/GET_ADYEN_PAYMENT_METHODS_REQUEST');
export const getAdyenPaymentMethodsSuccess = createStandardAction('@@app/GET_ADYEN_PAYMENT_METHODS_SUCCESS')<PaymentMethodsResponseObject>();
export const getAdyenPaymentMethodsFailure = createStandardAction('@@app/GET_ADYEN_PAYMENT_METHODS_FAILURE')<SubscriptionErrorInfo>();

export interface PaymentMethodsResponseObject {
    paymentMethods: any[];
    storedPaymentMethods?: any[];
    groups?: any;
    oneClickPaymentMethods?: any;
}
